import { post } from "shared-utils";

import type { DimensionValue, MetricValue, TableData, TimeRange } from "./types";

const OUTPUT_VERSION = "v3";

export type DataPrefix =
  | "marketing"
  | "customers"
  | "products"
  | "products_insights"
  | "google_ads_tabs"
  | "google_ads_objective_table"
  | "google_ads_performance_table"
  | "meta_ads_tabs"
  | "meta_ads_objective_table"
  | "meta_ads_performance_table"
  | "ltv_cac"
  | "meta_insights"
  | "meta_insights_overview"
  | "meta_insights_audience_type"
  | "meta_insights_audience"
  | "meta_insights_campaign_table"
  | "google_insights_campaign"
  | "google_insights_performance_table"
  | "google_insights"
  | "google_insights_ctr"
  | "meta_insights_ctr"
  | "meta_insights_overview_ctr"
  | "meta_insights_audience_type_ctr"
  | "meta_insights_audience_ctr"
  | "meta_insights_campaign_table_ctr"
  | "meta_insights_adset_metrics_ctr"
  | "meta_insights_adset_properties"
  | "google_insights_campaign_ctr"
  | "google_insights_performance_table_ctr"
  | "ltv_cac_monthly_insights"
  | "ltv_cac_quarterly_insights"
  | "ltv_cac_daily_insights"
  | "customer_churn_monthly"
  | "customer_churn_quarterly"
  | "channels"
  | "overview_insights"
  | "revenue_insights"
  | "tiktok_insights_ctr"
  | "tiktok_insights_accounts_ctr"
  | "test";

export default function fetchDashboardData(
  dashboardDataPath: string,
  dataPrefix: DataPrefix | string,
  timeRange: TimeRange,
  partitionDimensions: DimensionValue[],
  groupByDimensions: string[],
  filterDimensions: DimensionValue[],
  filterMetrics: MetricValue[],
  onSuccess: (data: TableData) => any,
  onFailure: (failureMessage: string) => any
) {
  post(
    dashboardDataPath,
    {
      version: OUTPUT_VERSION,
      dataPrefix: dataPrefix,
      timeRange: timeRange,
      partitionDimensions: partitionDimensions,
      groupByDimensions: groupByDimensions,
      filterDimensions: filterDimensions,
      filterMetrics: filterMetrics,
    },
    onSuccess,
    onFailure
  );
}
